import { Component } from '@angular/core';

import { ActivatedRoute } from '@angular/router';

import { ConfigurationService } from 'app/providers/semantria-api/configuration.service';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';
import { ConfigurationDetailsTabBase } from '../configuration-details-tab-base';
import { ConfigurationVersionTrackerService } from '../../services/configuration-version-tracker.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-configuration-blacklist',
  templateUrl: './configuration-blacklist.component.html',
  styleUrls: ['./configuration-blacklist.component.scss'],
  standalone: false,
})
export class ConfigurationBlacklistComponent extends ConfigurationDetailsTabBase {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  constructor(
    protected route: ActivatedRoute,
    protected configVersionTracker: ConfigurationVersionTrackerService,
    private configService: ConfigurationService
  ) {
    super(route, configVersionTracker);

    this.loadItems = this.configService.getBlacklists.bind(this.configService);
    this.createItem = this.configService.createBlacklistEntry.bind(this.configService);
    this.saveItem = this.configService.saveBlacklistEntry.bind(this.configService);
    this.deleteItem = this.configService.deleteBlacklistEntry.bind(this.configService);
    this.deleteAllItems = this.configService.deleteAllBlacklistEntries.bind(this.configService);
  }

  onItemsLoaded(items) {
    super.onItemsLoaded(items);

    if (this.selectedItemName) {
      const existingItem = this.itemList.find((item) => item.name === this.selectedItemName);
      if (existingItem) {
        this.editor.selectItem(existingItem, true);
      } else {
        this.editor.triggerAddButtonPopover(this.selectedItemName);
      }
    }
  }
}
